import * as Scrivito from "scrivito";

const ImageFooterWidget = Scrivito.provideWidgetClass("ImageFooterWidget", {
  onlyInside: "FooterContainerWidget",
  attributes: {
    title: "string",
    text: "html",
    image: ["reference", { only: "Image" }],
    link: "link",
  },
  extractTextAttributes: ["title", "text"],
});

export default ImageFooterWidget;
